import type { InfoPageContent } from './infoTypes';

export const termsContent: InfoPageContent = {
  title: 'Terms & Conditions',
  tagline: 'The terms that govern your use of Pilum Trade Lab. By using the application you accept them.',
  lastUpdated: 'August 7, 2026',
  sections: [
    {
      heading: '1 · Acceptance of these terms',
      paragraphs: [
        'By accessing or using Pilum Trade Lab (“the application”, “we”, “us”), you agree to these Terms & Conditions. If you do not agree, do not use the application.',
        'The application is provided free of charge and without a login. Using it does not create an account, a custodial relationship, or any financial service relationship.',
      ],
    },
    {
      heading: '2 · What the application is',
      paragraphs: [
        'Pilum Trade Lab is a research and monitoring tool that filters public market data and presents candidate observations for your own review. It is not an exchange, a broker, an investment adviser, or a signal-selling service.',
      ],
    },
    {
      heading: '3 · Not financial advice',
      paragraphs: [
        'Nothing in the application constitutes financial, investment, legal, or tax advice. Candidate observations are data-driven research outputs, not recommendations. You alone are responsible for your trading decisions.',
      ],
    },
    {
      heading: '4 · No warranty',
      paragraphs: [
        'The application is provided “as is” and “as available” without warranties of any kind, express or implied, including accuracy, completeness, uninterrupted availability, or fitness for a particular purpose. Public market data feeds can be delayed, incomplete, or incorrect, and the application presents them without independent audit.',
      ],
    },
    {
      heading: '5 · Limitation of liability',
      paragraphs: [
        'To the maximum extent permitted by law, we are not liable for any direct, indirect, incidental, consequential, or special damages arising from your use of, or inability to use, the application — including trading losses, missed opportunities, or decisions made from its output.',
      ],
    },
    {
      heading: '6 · Acceptable use',
      bullets: [
        'Do not attempt to disrupt, overload, or abuse the application or its public data sources.',
        'Do not use the application for unlawful purposes.',
        'Do not resell or repackage the application or its data as your own service without permission.',
        'Respect the rate limits and terms of the third-party public feeds the application uses.',
      ],
    },
    {
      heading: '7 · Third-party data sources',
      paragraphs: [
        'The application reads public data from exchanges and market-data providers including Binance, Bybit, OKX, CoinGecko, and DexScreener. Those providers are independent and their data is used subject to their own terms. We do not guarantee the accuracy or availability of any third-party feed.',
      ],
    },
    {
      heading: '8 · No accounts or stored funds',
      paragraphs: [
        'The application never holds your funds, never requests exchange credentials or private keys, and never executes trades. Any data stored locally in your browser is yours and is deleted when you clear your browser data.',
      ],
    },
    {
      heading: '9 · Availability and interruptions',
      paragraphs: [
        'The application may be updated, changed, or taken offline at any time without notice. Radar monitoring depends on your browser staying open and connected; browsers may suspend inactive or closed tabs.',
      ],
    },
    {
      heading: '10 · Intellectual property',
      paragraphs: [
        'The application, its design, and its code are provided under the project’s license. Public market data belongs to its respective providers. Nothing in these terms transfers any ownership to you.',
      ],
    },
    {
      heading: '11 · Changes to these terms',
      paragraphs: [
        'We may revise these Terms & Conditions at any time. Continued use of the application after changes take effect constitutes acceptance of the revised terms. The “last updated” date at the top of this page reflects the current version.',
      ],
    },
  ],
};
